module.exports = __webpack_public_path__ + "static/media/crocodile-icefish.c7bf627a.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/fish/crocodile-icefish.png
// module id = 307
// module chunks = 0